import styleInject from '../../util/injectCss.js';

var css_248z = ".ScrollNav__tHzQe_v2 {\n  display: flex; }\n  .ScrollNav_sections__E9Dgc_v2 {\n    position: sticky;\n    top: 1rem;\n    flex-shrink: 0;\n    align-self: flex-start;\n    margin: 0 4rem 0 2.5rem; }\n  .ScrollNavSection__ia5DP_v2 {\n  overflow: hidden; }\n  .ChildrenContainer__IHVsf_v2 {\n  flex-grow: 1; }\n";
var styles = {"ScrollNav":"ScrollNav__tHzQe_v2","ScrollNav_sections":"ScrollNav_sections__E9Dgc_v2","ScrollNavSection":"ScrollNavSection__ia5DP_v2","ChildrenContainer":"ChildrenContainer__IHVsf_v2"};
styleInject(css_248z);

export { styles as default };
